<template>
  <page-view :ml="!isForgotten" class="page-reset-pass mwclg-style">
    <template #pageRight>
      <div
        class="reset-pass-block"
        v-loading="fullscreenLoading"
        :element-loading-text="$t('CompanyInformation.Loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(196,196,204, 0.8)"
      >
        <p class="title">
          {{
            isForgotten
              ? $t('ChangePassword.ForgotPassword')
              : $t('ChangePassword.ChangePassword')
          }}
        </p>
        <div class="flex reset-pass-form-container">
          <el-form
            ref="passForm"
            :model="passForm"
            :rules="passFormRules"
            :validate-on-rule-change="false"
            :label-width="$ls.get('lang') == 'zh' ? '100px' : '140px'"
          >
            <el-row :gutter="16" style="width: 400px">
              <!-- <el-col :span="24">
                <el-form-item label="旧密码" prop="oldPassword">
                  <el-input
                    v-model="passForm.oldPassword"
                    type="password"
                    size="small"
                    placeholder="请输入旧密码"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item
                  :label="$t('ChangePassword.Account')"
                  prop="caCode"
                  class="account-item"
                >
                  <el-input
                    v-model="passForm.caCode"
                    size="small"
                    :disabled="!isForgotten"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                  <el-button
                    type="primary"
                    size="small"
                    v-if="$ls.get('lang') == 'zh'"
                    :disabled="!!secCount"
                    @click="clickToSendCode"
                    >{{
                      secCount
                        ? secCount + ' 秒后重试'
                        : $t('ChangePassword.SendVerificationCode')
                    }}</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    v-else
                    :disabled="!!secCount"
                    @click="clickToSendCode"
                    >{{
                      secCount
                        ? `Try again in ${secCount} seconds`
                        : $t('ChangePassword.SendVerificationCode')
                    }}</el-button
                  >
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24">
                <el-form-item label="邮箱" prop="email" class="email-item">
                  <el-input
                    v-model="passForm.email"
                    size="small"
                    disabled
                    placeholder="请输入邮箱地址"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item
                  :label="$t('ChangePassword.VerificationCode')"
                  prop="verificationCode"
                >
                  <el-input
                    v-model="passForm.verificationCode"
                    size="small"
                    :maxlength="6"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item
                  :label="$t('ChangePassword.NewPassword')"
                  prop="newCaPassword"
                >
                  <el-input
                    v-model="passForm.newCaPassword"
                    type="password"
                    size="small"
                    show-password
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$t('ChangePassword.ConfirmPassword')"
                  prop="confirmPassword"
                >
                  <el-input
                    v-model="passForm.confirmPassword"
                    type="password"
                    size="small"
                    show-password
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="form-botton-group">
            <el-button
              type="primary"
              size="medium"
              :loading="submitLoading"
              @click="submitPassForm"
              >{{ $t('ChangePassword.Submit') }}</el-button
            >
          </div>
        </div>
      </div>
    </template>
    <el-dialog></el-dialog>
  </page-view>
</template>

<script>
// import { throttle } from 'lodash'
import { PageView } from '@/components'
import { mapActions } from 'vuex'
import { sendVerificationCode, retrievePassword } from '@/api/user'
import { USER_INFO } from '@/store/mutation-types'
import { HttpResponseCode } from '@/utils/request'
import md5 from 'md5'
import i18n from '@/i18n/i18n'
export default {
  components: {
    PageView
  },
  data() {
    return {
      fullscreenLoading: false,
      passForm: {
        caCode: '',
        verificationCode: '',
        newCaPassword: '',
        confirmPassword: ''
      },
      submitLoading: false,
      countdownTimer: null,
      secCount: 0
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
    isForgotten() {
      return this.$route.name === 'FindPassword'
    },
    passFormRules() {
      const _this = this
      return {
        caCode: [
          { required: true, trigger: 'blur', message: i18n.t('ChangePassword.loginAccount') }
        ],
        email: [
          { required: true, trigger: 'blur', type: 'email', message: i18n.t('ChangePassword.EmailAddress') }
        ],
        verificationCode: [
          { required: true, trigger: 'blur', pattern: /^\w{6}$/, message: i18n.t('ChangePassword.CaptchaCode') }
        ],
        newCaPassword: [
          { required: true, trigger: 'blur', message: i18n.t('ChangePassword.EnterNewPassword') }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', message: i18n.t('ChangePassword.NewPasswordAgain') },
          { validator: _this.confirmPassValidator }
        ]
      }
    },
    resetWording() {
      return this.isForgotten ? i18n.t('ChangePassword.Reset') : i18n.t('ChangePassword.Edit')
    }
  },
  created() {
    if (!this.isForgotten) {
      this.passForm.caCode = this.userInfo.CACode || ''
    }
    if (this.$route.query.lang) {
      this.changeLangauge(this.$route.query.lang)
    }
  },
  methods: {
    ...mapActions('user', ['logout']),
    confirmPassValidator(rule, value, callback, source, options, isRequired = false) {
      if (!value && !isRequired) {
        callback()
      } else if (!value) {
        callback(new Error(i18n.t('ChangePassword.NewPasswordAgain')))
      } else if (value !== this.passForm.newCaPassword) {
        callback(new Error(i18n.t('ChangePassword.Inconsistent')))
      } else {
        callback()
      }
    },
    changeLangauge(lang) {
      this.$i18n.locale = lang
      this.$ls.set('lang', lang)
    },
    async submitPassForm() {
      const _this = this
      this.$refs.passForm.validate(async valid => {
        if (valid) {
          await this.$confirm(i18n.t('ChangePassword.Continue'), i18n.t('ChangePassword.Prompt'), {
            confirmButtonText: i18n.t('ServiceEvaluation.Confirm'),
            cancelButtonText: i18n.t('ServiceEvaluation.Cancel'),
            type: 'warning'
          }).then(async () => {
            _this.submitLoading = true
            const queryData = {
              ..._this.passForm,
              caCode: _this.isForgotten ? _this.passForm.caCode : _this.userInfo.CACode,
              newCaPassword: _this.passForm.newCaPassword
            }
            await retrievePassword(queryData).then(res => {
              if (res && res.code === HttpResponseCode.SUCCESS) {
                _this.$message({
                  type: 'success',
                  message: i18n.t('ChangePassword.PleaseLogInAgain'),
                  onClose() {
                    _this.logout()
                  }
                })
              }
            })
          }).catch(() => {
            console.log('cancel', `${this.resetWording}密码`)
          })
          _this.submitLoading = false
        }
      })
    },
    clickToSendCode() {
      if (!this.secCount) {
        const _this = this
        this.$refs.passForm.validateField('caCode', function (error) {
          if (!error) {
            sendVerificationCode({
              // email: _this.passForm.email,
              setName: '修改密码'
            }).then(res => {
              if (res && res.code.slice(-3) === '000') {
                _this.$message({
                  type: 'info',
                  message: i18n.t('ChangePassword.CodeHasBeenSent')
                })
                _this.secCount = 60
                _this.countdownTimer = setInterval(function () {
                  _this.secCount--
                  if (!_this.secCount) {
                    clearInterval(_this.countdownTimer)
                  }
                }, 1000)
              }
            })
          }
        })
      }
    },
  }
}
</script>

<style lang="less">
.page-reset-pass {
  padding: 10px;
  background: #f0f6fb;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .reset-pass-block {
    background: white;
    // margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height: 60vh;
    .list-item {
      margin-bottom: 8px;
    }

    .reset-pass-form-container {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      .form-botton-group {
        margin-top: 26px;
      }

      .el-form-item {
        &.is-error {
          margin-bottom: 22px;
          .el-form-item__error {
            left: 16px;
          }
        }
      }
      .el-input__inner {
        max-width: 300px;
      }

      .account-item {
        .el-form-item__content {
          display: flex;
          align-items: center;
          .el-button {
            width: 150px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
